// example theme.js

export default {
  breakpoints: ["40em", "52em", "64em"],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64],
  colors: {
    lightgray: "rgba(20, 20, 20, 0.8)",
    teal: "rgba(, 128, 128, 0.3)"
  },
  space: [0, 4, 8, 16, 32, 64, 128, 256],
  fonts: {
    sans: "Martel Sans, sans-serif",
    mono: "Menlo, monospace"
  },
  fontWeights: {
    lighter: "200"
  },
  shadows: {
    small: "0 0 4px rgba(0, 0, 0, .125)",
    large: "0 0 24px rgba(0, 0, 0, .125)"
  }
};
